var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mode && (_vm.mode == 'clone' || _vm.mode == 'edit' ||_vm.mode == 'new'))?_c('span',{class:_vm.show ? 'red--text' : 'transparent--text d-none d-lg-inline'},[_vm._v("*")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }